const activityOptions = {
  'Millennial movement': 'Millennial movement',
  'Winning Smile': 'Winning Smile',
  'Premium products': 'Premium products',
  'Data during the holidays': 'Data during the holidays',
  'Big data in the big game': 'Big data in the big game',
  'Data gets green': 'Data gets green',
  'Women & gender equity at 100': 'Women & gender equity at 100',
  'Using the Census for a U.S. snapshot':
    'Using the Census for a U.S. snapshot',
  'Understanding the election cycle': 'Understanding the election cycle',
};

export default activityOptions;
